import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const portainer = defineConnector({
  identifier: "portainer",
  name: "Portainer",
  tagLine: "Container management platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Portainer API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Portainer, go to **My Account** and generate an access token under **Access Tokens**.",
        },
      ],
    },
    {
      title: "Enter your Portainer details",
      items: [
        {
          kind: "baseUrl",
          label: "Portainer instance URL",
          required: true,
          placeholder: "https://portainer.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Portainer instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/status`,
  },
});
